// extracted by mini-css-extract-plugin
export var badge = "exploreFeature-module--badge--b6b47";
export var caret = "exploreFeature-module--caret--eb201";
export var categoryColumn = "exploreFeature-module--categoryColumn--ea236";
export var categoryItems = "exploreFeature-module--categoryItems--4cae4";
export var container = "exploreFeature-module--container--f84d4";
export var eyebrow = "exploreFeature-module--eyebrow--7f548";
export var feature = "exploreFeature-module--feature--8fd4c";
export var features = "exploreFeature-module--features--b9f51";
export var featuresWrap = "exploreFeature-module--featuresWrap--e3215";
export var icon = "exploreFeature-module--icon--88dd1";
export var open = "exploreFeature-module--open--4e343";
export var seeLess = "exploreFeature-module--seeLess--11f90";
export var seeMore = "exploreFeature-module--seeMore--bb0e6";
export var seeMoreContainer = "exploreFeature-module--seeMoreContainer--a504b";
export var text = "exploreFeature-module--text--43eec";
export var title = "exploreFeature-module--title--cfa6b";